/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import {
  MailOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from "@ant-design/icons";
import "./register.css";
import { postRequest } from "./../Auth/api"
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import axios from "axios";


const Register = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
// const email = localStorage.getItem("registeredEmail");
const onFinish = async (values) => {
  setLoading(true);
  const payload = {
    email: values.email,
    password: values.password,
    first_name: values.firstName,
    last_name: values.lastName,
    mobile_no: values.phone,
  };

  try {
    const response = await postRequest("register", payload);
    message.success("Registration successful!");
    localStorage.setItem("registeredEmail", values.email);
    navigate("/otp-verify", { state: { email: values.email } });
    console.log(response) 
  } catch (error) {
    message.error(error.message || "Registration failed.");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="register-container">
      <div className="register-left">
        <img src="/Images/register-img.png" alt="Signup Visual" />
      </div>

      <div className="register-right">
        <h2 className="register-heading">SIGN UP</h2>
        <Form layout="vertical" onFinish={onFinish} className="register-form">
          <div className="name-fields">
            <Form.Item
              name="firstName"
              label="First Name"
              rules={[{ required: true, message: "Please enter your first name" }]}
            >
              <Input placeholder="John" />
            </Form.Item>
            <Form.Item
              name="lastName"
              label="Last Name"
              rules={[{ required: true, message: "Please enter your last name" }]}
            >
              <Input placeholder="Doe" />
            </Form.Item>
          </div>

          <Form.Item
            name="email"
            label="Email Id"
            rules={[{ required: true, type: "email", message: "Enter a valid email" }]}
          >
            <Input prefix={<MailOutlined />} placeholder="johndoe@gmail.com" />
          </Form.Item>

          <Form.Item
            name="phone"
            label="Phone Number"
            rules={[{ required: true, message: "Please enter your phone number" }]}
          >
            <Input placeholder="9876543210" />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <Input.Password
              placeholder="Password@123"
              iconRender={(visible) => visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
            />
          </Form.Item>

          <Form.Item
            name="confirm"
            label="Confirm Password"
            dependencies={["password"]}
            rules={[
              { required: true, message: "Please confirm your password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Confirm Password"
              iconRender={(visible) => visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="register-btn"
              loading={loading}
            >
              SIGN UP
            </Button>
          </Form.Item>
        </Form>

        <div className="or-btn">
          <img src="/Images/login-or.png" />
        </div>

       <div className="google-btn">
          <GoogleLogin
            onSuccess={async (credentialResponse) => {
              try {
                const decoded = jwtDecode(credentialResponse.credential);
                const response = await axios.post(
                  "https://cafemandhurah.mandurahcafe.com.au/api/login",
                  {
                    email: decoded.email,
                    name: decoded.name,
                    social_login_provider: "google",
                    // token: credentialResponse.credential,
                  },
                  {
                    headers: {
                      "Content-Type": "application/json",
                    },
                  }
                );

                if (response?.data?.access_token) {
                  localStorage.setItem("token", response.data.access_token);
                  message.success("Google login successful!");
                  window.location.href = "/view-our-menu";
                  localStorage.setItem(
                    "Userdata",
                    JSON.stringify(response.data.user)
                  );
                  localStorage.setItem(
                    "UserId",
                    JSON.stringify(response?.data?.user?.id)
                  );
                } else {
                  message.error("Google login failed.");
                }
              } catch (err) {
                console.error(err);
                message.error("Google login error.");
              }
            }}
            onError={() => {
              message.error("Google Sign In was unsuccessful.");
            }}
          />
        </div>


        <p className="register-link">
          Already have an account? <a href="/login">Log In</a>
        </p>
        <p className="terms-text">
          By signing up, you agree to our <a>T&C</a> and <a>Privacy Policy</a>.
        </p>
      </div>
    </div>
  );
};

export default Register;
